var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisputeEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dispute empty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "169.961462%",
    y1: "-324.053889%",
    x2: "38.5316377%",
    y2: "125.542689%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44C0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F9F0",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 34.3414634,
    height: 33.5206612
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "resized-illustrations_version-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dispute-empty"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logistics-empty"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    x: 0,
    y: 0,
    width: 300,
    height: 300
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.254584,151.741573 C264.589504,212.19705 215.411011,261 154.842324,261 C93.8595457,261 44.4232365,211.527465 44.4232365,150.5 C44.4232365,145.447329 44.7621099,140.473863 45.4183532,135.601124 L10.9325843,135.601124 C5.44696945,135.601124 1,131.154154 1,125.668539 C1,120.182925 5.44696945,115.735955 10.9325843,115.735955 L49.9985591,115.735955 L89.0798639,115.735955 C94.5654787,115.735955 99.0124481,111.288986 99.0124481,105.803371 C99.0124481,101.536153 96.3215139,97.8974372 92.543996,96.491573 C91.4654202,96.8929824 90.2982612,97.1123596 89.0798639,97.1123596 L43.1898457,97.1123596 C37.7042309,97.1123596 33.2572614,92.6653901 33.2572614,87.1797753 C33.2572614,81.6941605 37.7042309,77.247191 43.1898457,77.247191 L72.1710885,77.247191 C92.4001989,54.4006708 121.940764,40 154.842324,40 C202.299058,40 242.763324,69.9602512 258.37869,112.011236 L290.067416,112.011236 C295.553031,112.011236 300,116.458205 300,121.94382 C300,127.429435 295.553031,131.876404 290.067416,131.876404 L263.699818,131.876404 L241.69607,131.876404 C236.210455,131.876404 231.763485,136.323374 231.763485,141.808989 C231.763485,147.294604 236.210455,151.741573 241.69607,151.741573 L265.254584,151.741573 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(87.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-30",
    stroke: "#64808C",
    fill: "#FFFFFF",
    points: "0 17.6015069 11.2756457 2.27373675e-13 109.928693 2.27373675e-13 121.145005 17.6015069"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,17.7950034 C0,17.7950034 0,52.4263615 0,121.689078 L121.437786,121.689078 L121.437786,17.7950034 C40.4792621,17.7950034 0,17.7950034 0,17.7950034 Z",
    id: "Path-38",
    stroke: "#64808C",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(96.000000, 85.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-10",
    fill: "#EB8181",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2171186,32.2322536 L14.3021469,32.6328716 C14.0808907,32.6791591 13.9223989,32.874239 13.9223989,33.1002852 L13.9223989,33.1002852 C13.9223989,33.3145546 14.0960985,33.4882542 14.3103679,33.4882542 L25.6173424,33.4882542 C25.8328563,33.4882542 26.0075649,33.3135456 26.0075649,33.0980317 L26.0075649,33.0980317 C26.0075649,32.87081 25.8479305,32.6748525 25.6254016,32.6289113 L23.6931657,32.2300001 C22.34552,31.9517779 21.3787665,30.76505 21.3787665,29.3889845 L21.3787665,26.0697423 C21.6793376,24.812783 22.7387394,23.6555802 24.556972,22.5981339 C27.2843209,21.0119645 31.5751778,14.9775437 26.9671969,7 L24.3435417,7.01277286 L25.2581059,9.85672562 L23.47691,11.8082263 L24.1965851,17.7238458 L20.213513,11.8082263 L22.4266513,9.85672562 L20.5108597,7.01277286 L13.0534324,7.01277286 C9.56593806,13.8952841 10.5207437,19.1789905 15.9178492,22.8638918 C17.2687363,23.7209934 18.1333994,24.7896103 18.5118384,26.0697423 C18.7511597,26.8792856 18.8391365,27.9343853 18.7757688,29.2350416 L18.7757671,29.2350415 C18.7043951,30.6999905 17.6527263,31.93192 16.2171186,32.2322536 Z",
    id: "Path-44",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(10.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-47"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#64808C",
    strokeWidth: 1,
    x: 0.5,
    y: 0.5,
    width: 33.3414634,
    height: 32.5206612
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.72195122,4.72727273 L31.3504291,4.72727273",
    id: "Line-35",
    stroke: "#64808C",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72195122,10.7438017 L15.8829268,10.7438017",
    id: "Line-35-Copy",
    stroke: "#64808C",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72195122,15.0413223 L15.8829268,15.0413223",
    id: "Line-35-Copy-2",
    stroke: "#64808C",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72195122,19.338843 L15.8829268,19.338843",
    id: "Line-35-Copy-3",
    stroke: "#64808C",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72195122,23.6363636 L15.8829268,23.6363636",
    id: "Line-35-Copy-4",
    stroke: "#64808C",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72195122,27.9338843 L15.8829268,27.9338843",
    id: "Line-35-Copy-5",
    stroke: "#64808C",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-48",
    fill: "#EB8181",
    x: 18.8878049,
    y: 9.45454545,
    width: 11.1609756,
    height: 8.59504132
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-48-Copy",
    fill: "#87D5FA",
    x: 18.8878049,
    y: 19.768595,
    width: 11.1609756,
    height: 8.59504132
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-42",
    stroke: "#64808C",
    fill: "#87D5FA",
    points: "50.5842398 0 47 17.4702653 47 49.0633968 60.3327047 39 73.6654094 49.0633968 73.6654094 18.1014514 68.230827 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5,17.5 L73.5192237,17.5",
    id: "Line-42",
    stroke: "#64808C",
    strokeLinecap: "square"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputeEmpty);
export default __webpack_public_path__ + "static/media/dispute-empty.795ba49429f937ec718b1456d7ffaa02.svg";
export { ForwardRef as ReactComponent };